import type { User } from '@policyvision/contracts';

import { Client } from '@/common/services/Client';
type UsersPayload = {
  users: User[];
};
export async function fetchUsers(): Promise<User[]> {
  const response = await Client.get<UsersPayload>({
    endpoint: '/users',
  });
  return response.data.users;
}
